/**
 * Template slice (SCRUM-1952, RTK bundle 3) — the former switch reducer
 * templateReducer.js as createSlice. Behaviour-preserving: every case answers
 * the same legacy action type string (templateTypes.js) that templateAction.js
 * already dispatches, and returns the same state. The actions module is
 * unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/contentReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import { legacyCases } from "../legacyCases";
import {
  POST_TEMPLATE,
  GET_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_TEMPLATE_BY_DESIGN,
  SAVE_SETTINGS_REQUIRED,
  SAVE_SETTINGS_OPTIONAL,
} from "./templateTypes";

type TemplateState = {
  templates: any[];
  addTemplate: any;
  templates_by_design_site: any[];
  template_updated: any;
  settings_required: any[];
  settings_optional: any[];
};

const initialState: TemplateState = {
  templates: [],
  addTemplate: {},
  templates_by_design_site: [],
  template_updated: {},
  settings_required: [],
  settings_optional: [],
};

const templateCases = {
  [POST_TEMPLATE]: (state: TemplateState, payload: TemplateState["addTemplate"]) => ({
    ...state,
    addTemplate: payload,
    templates: [...state.templates, payload],
  }),
  [GET_TEMPLATE]: "templates" as const,
  [DELETE_TEMPLATE]: (state: TemplateState, payload: string) => ({
    ...state,
    templates: state.templates.filter((template) => template._id !== payload),
  }),
  [UPDATE_TEMPLATE]: "template_updated" as const,
  [SAVE_SETTINGS_REQUIRED]: "settings_required" as const,
  [SAVE_SETTINGS_OPTIONAL]: "settings_optional" as const,
  [GET_TEMPLATE_BY_DESIGN]: "templates_by_design_site" as const,
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    legacyCases(builder, templateCases);
  },
});

export default templateSlice.reducer;
